import {Injectable} from "@angular/core";
import {ToastrService} from "ngx-toastr";
import { HttpErrorResponse } from "@angular/common/http";
import { ApiErrorDetail } from "../app.types";

@Injectable({
    providedIn: "root"
})
export class HttpErrorService {

    constructor(private toastrService: ToastrService) {
    }

    /**
     * Pulls the structured details out of an API error response, if it carries any.
     * @param {HttpErrorResponse | any} error
     * @returns {ApiErrorDetail[]} the details, or an empty array for any other kind of failure
     */
    getErrorDetails(error: HttpErrorResponse | any): ApiErrorDetail[] {
        const details = error?.error?.error?.details;

        return Array.isArray(details) ? details : [];
    }

    handleHttpError(error: HttpErrorResponse | any) {
        if (error == null) {return;}

        // Status 0: Unknown Error
        if (error.status == 0) {
            this.toastrService.error(error.statusText, "Error Code: " + error.status);
        }

        // Status 400: Bad Request
        else if (error.status == 400) {
            const details = this.getErrorDetails(error);

            if (details.length > 0) {
                this.toastrService.error(details[0].message, "Error Code: " + error.status);
            } else {
                this.toastrService.error(error.statusText, "Error Code: " + error.status);
            }
        }

        // Status 401: Unauthorised
        else if (error.status == 401) {
            this.toastrService.error(error.statusText, "Error Code: " + error.status);
        }

        // Status 403: Forbidden
        else if (error.status == 403) {
            this.toastrService.error(error.statusText, "Error Code: " + error.status);
        }

        // Status 404: Not Found
        else if (error.status == 404) {
            this.toastrService.error(error.statusText, "Error Code: " + error.status);
        }

        // Status 500: Internal Server Error
        else if (error.status == 500) {
            this.toastrService.error(error.statusText, "Error Code: " + error.status);
        }

        // Timeout error
        else if (error.name == "TimeoutError") {
            this.toastrService.error("Server did not respond to the request within the required time", "Timeout");
        }

        else {
            this.toastrService.error(error.statusText, "Unknown Error!");
        }
    }

}
